import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucideArrowLeft, lucideCircleAlert, lucideRefreshCw } from '@ng-icons/lucide';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmIconDirective } from '@spartan-ng/ui-icon-helm';

@Component({
  selector: 'app-error-message',
  standalone: true,
  imports: [CommonModule, NgIcon, HlmButtonDirective, HlmIconDirective],
  providers: [
    provideIcons({
      lucideCircleAlert,
      lucideRefreshCw,
      lucideArrowLeft,
    }),
  ],
  template: `
    <div
      role="alert"
      class="rounded-lg border border-red-200 bg-red-50 p-6 text-center dark:border-red-900 dark:bg-red-900/20"
    >
      <ng-icon hlm [size]="'xl'" [name]="'lucideCircleAlert'" class="text-red-500 mb-4" />
      <h2 class="mb-2 text-lg font-semibold text-gray-900 dark:text-gray-100">{{ title() }}</h2>
      <p class="mb-4 text-gray-600 dark:text-gray-300">{{ message() }}</p>
      @if (showRetryButton()) {
        <button hlmBtn (click)="retry.emit()">
          <ng-icon hlm [size]="'sm'" [name]="buttonIcon()" class="mr-2" />
          {{ retryButtonText() }}
        </button>
      }
    </div>
  `,
})
export class ErrorMessageComponent {
  readonly title = input('Error');
  readonly message = input.required<string>();
  readonly showRetryButton = input(true);
  readonly retryButtonText = input('Retry');
  readonly buttonIcon = input('lucideRefreshCw');

  readonly retry = output<void>();
}
